import React from 'react';
import { 
  Box, 
  Container, 
  Stack, 
  Text, 
  Link, 
  Flex, 
  Icon, 
  Divider 
} from '@chakra-ui/react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="gray.800"
      color="white"
      py={6}
      mt={10}
    >
      <Container maxW="container.xl">
        <Flex direction={{ base: 'column', md: 'row' }} justify="space-between" align="center">
          <Stack direction="column" spacing={2} mb={{ base: 4, md: 0 }}>
            <Text fontWeight="bold" fontSize="lg">Abhishek Bhalerao</Text>
            <Text fontSize="sm">Full Stack Developer | Industrial Automation | Robotics Engineering</Text>
          </Stack>
          
          <Stack direction="row" spacing={6}>
            <Stack direction="column" spacing={2} align="flex-start">
              <Text fontWeight="bold" mb={2}>Quick Links</Text>
              <Link as={RouterLink} to="/" _hover={{ color: 'blue.300' }}>Home</Link>
              <Link as={RouterLink} to="/about" _hover={{ color: 'blue.300' }}>About</Link>
              <Link as={RouterLink} to="/projects" _hover={{ color: 'blue.300' }}>Projects</Link>
              <Link as={RouterLink} to="/contact" _hover={{ color: 'blue.300' }}>Contact</Link>
            </Stack>
            
            <Stack direction="column" spacing={2} align="flex-start">
              <Text fontWeight="bold" mb={2}>Projects</Text>
              <Link as={RouterLink} to="/projects/esp-boardpulse" _hover={{ color: 'blue.300' }}>ESP BoardPulse</Link>
              <Link as={RouterLink} to="/projects/spl-meter" _hover={{ color: 'blue.300' }}>SPL Meter</Link>
              <Link as={RouterLink} to="/projects" _hover={{ color: 'blue.300' }}>View All</Link>
            </Stack>
          </Stack>
        </Flex>
        
        <Divider my={4} />
        
        <Flex justify="space-between" align="center" direction={{ base: 'column', sm: 'row' }}>
          <Text fontSize="sm">
            &copy; {new Date().getFullYear()} Abhishek Bhalerao. All rights reserved.
          </Text>
          
          <Stack direction="row" spacing={4} mt={{ base: 4, sm: 0 }}>
            <Link href="https://github.com/AbhishekB2023" isExternal>
              <Icon as={FaGithub} boxSize={5} _hover={{ color: 'blue.300' }} />
            </Link>
            <Link href="https://x.com/@AbhishekB85" isExternal>
              <Icon as={FaXTwitter} boxSize={5} _hover={{ color: 'blue.300' }} />
            </Link>
            <Link href="https://linkedin.com/in/abhishek-bhalerao-68781a3a" isExternal>
              <Icon as={FaLinkedin} boxSize={5} _hover={{ color: 'blue.300' }} />
            </Link>
          </Stack>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;







